import React, { FC } from "react";
import { GraphQLClientProvider } from "@edreamsodigeo/frontend-api-client-base";
import { GraphQLClientProviderProps } from "./graphql/client/types";

export type FrontendApiClientProviderProps = GraphQLClientProviderProps;

export const FrontendApiClientProvider: FC<FrontendApiClientProviderProps> = ({
  children,
  graphQLClient,
}) => (
  <GraphQLClientProvider graphQLClient={graphQLClient}>
    {children}
  </GraphQLClientProvider>
);
